import { useTheme } from '@mui/material';
import { FieldRenderBlockProp } from '../..';
import ListAvatarBlock from '../../_utils/list-avatar-block';

export default function DiscordBlockRenderer(props: FieldRenderBlockProp) {
  const theme = useTheme();

  if (!props.data?.discord) return <></>;

  return (
    <ListAvatarBlock
      title={props.data.discord?.title}
      value={props.data.discord?.value}
      e={props}
    />
  );
}
